import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ContextPage } from "../../modules/page/pageContext";
import "./styles.css";

// Хлебные крошки текущей страницы (цепочку собирает ProviderPage через inc/Breadcrumbs).
export default function Breadcrumbs() {
    const contextPage = useContext(ContextPage);
    const items = (contextPage && contextPage.breadcrumb) ? contextPage.breadcrumb : [];
    if (items.length === 0) return null;

    return <nav className="breadcrumbs">
        {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return <span key={index} className="breadcrumbs__item">
                {(item.url && !isLast)
                    ? <Link className="breadcrumbs__link" to={item.url}>{item.label}</Link>
                    : <span className="breadcrumbs__current">{item.label}</span>}
                {!isLast ? <span className="breadcrumbs__divider">/</span> : null}
            </span>;
        })}
    </nav>;
}
